import React from 'react';
import { Link } from 'react-router-dom';

function PageNotFound() {
  return (
    <main className="h-screen w-full flex flex-col justify-center items-center bg-gray-900">
      <h1 className="text-9xl font-extrabold text-white tracking-widest">
        404
      </h1>
      <div className="bg-blue-600 text-white px-2 text-sm rounded">
        Page Not Found
      </div>
      <p className="text-white mt-5 max-w-sm text-center">
        La pagina richiesta non esiste, ti consigliamo di tornare nella homepage
      </p>
      <button className="mt-5">
        <span className="relative inline-block text-sm font-medium text-blue-600 group active:text-orange-500 focus:outline-none focus:ring">
          <span className="absolute inset-0 transition-transform translate-x-0.5 translate-y-0.5 bg-blue-600 group-hover:translate-y-0 group-hover:translate-x-0"></span>

          <span className="relative block px-8 py-3 bg-[#1A2238] border border-current">
            <Link to="/">Homepage</Link>
          </span>
        </span>
      </button>
    </main>
  );
}

export default PageNotFound;
